import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import TeacherPostReviewListStore, {
  PostReviewScopeT,
} from './TeacherPostReviewListStore';
import { useStore } from 'hooks/useStore';
import { PostT } from 'types/shared/core/Post';
import { Box, useTheme } from '@mui/material';
import Feeds from 'presenters/Feed/Feeds';
import EmptyState from 'presenters/common/EmptyState';
import ContentArea from 'presenters/common/ContentArea';
import { FeedItemT } from 'types/shared/core/Feeds';
import PostReviewActions from './PostReviewActions';

const PostReviewListOf = observer(({ scope }: { scope: PostReviewScopeT }) => {
  const { init, feedsOf, handleFeedItemClick, handlePostCornerAction } =
    useStore<TeacherPostReviewListStore>('TeacherPostReviewListStore');

  const { palette } = useTheme();

  useEffect(() => {
    init(scope);
  }, [scope]);

  const scopedHandleFeedItemClick = useCallback(
    (feedItem: FeedItemT) => handleFeedItemClick(scope, feedItem),
    [scope],
  );

  const scopedHandlePostCornerAction =
    scope === 'mine' ? handlePostCornerAction : undefined;

  const customActionComponent:
    | React.ComponentType<{
        post: PostT;
      }>
    | undefined = scope === 'inbox' ? PostReviewActions : undefined;

  const feeds = feedsOf[scope];

  const emptyStateMessage =
    scope === 'inbox' ? '검토할 글이 없습니다.' : '검토 요청글이 없습니다.';

  return (
    <ContentArea>
      {feeds.length ? (
        <Feeds
          listKey={scope}
          feeds={feeds}
          perspective="teacherSide"
          onEnd={() => {
            console.log('검토 대상 글은 페이지네이션이 없다.');
          }}
          onClick={scopedHandleFeedItemClick}
          onClickPostCornerAction={scopedHandlePostCornerAction}
          CustomActionsComponent={customActionComponent}
        />
      ) : (
        <EmptyState message={emptyStateMessage} background="default" delayMs={0} />
      )}
      {/* 검정 배경 채우는 용도 */}
      <Box sx={{ flexGrow: 1, background: palette.background.default }} />
    </ContentArea>
  );
});
export default PostReviewListOf;
